// extracted by mini-css-extract-plugin
module.exports = {"root":"CosmeticCreateEdit_root__3z_T3"};